import * as z from "zod/v4";

export const generatePointsRedemptionReport = {
  name: "generatePointsRedemptionReport" as const,
  input: z.object({
    month: z.number().int().min(1).max(12),
    year: z.number().int(),
  }),
  output: z.object({ csv: z.string() }),
};
